export const isDevelopment = import.meta.env.MODE === 'development';

export const isProduction =
  import.meta.env.MODE === 'production' || import.meta.env.MODE === 'test' || import.meta.env.MODE === 'demo';
